var _defs, _g, _g2, _line, _line2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCoefTempFereastra(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "edb4a68a-d0d3-41ca-bd37-67a78ef9f5b8",
    "data-name": "coef_temp_fereastra",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a79b4e26-55a2-4988-acd9-503bccd785e8,.e7113f9c-c57a-403e-b49e-d80a38b185d8,.e9d71768-2015-48a9-b692-94bd591fb52f,.ea472750-dd51-4dbe-9fe2-e042b1899a49,.eae3bf02-3ca4-473c-a53a-952a2d6e8ddd{fill:none;stroke:#000;stroke-linecap:round;stroke-linejoin:round;}.e9d71768-2015-48a9-b692-94bd591fb52f{stroke-width:8px;}.a79b4e26-55a2-4988-acd9-503bccd785e8{stroke-width:3px;}.e7113f9c-c57a-403e-b49e-d80a38b185d8{stroke-width:6px;}.eae3bf02-3ca4-473c-a53a-952a2d6e8ddd{stroke-width:10px;}.ea472750-dd51-4dbe-9fe2-e042b1899a49{stroke-width:5px;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "coef_temp_fereastra") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "e37c0e81-d935-41a9-9af2-6ed7b1e021c2",
    "data-name": "termostat copy 2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "e9d71768-2015-48a9-b692-94bd591fb52f",
    d: "M35.41,161.06a19.5,19.5,0,1,1-23.85,0",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "e9d71768-2015-48a9-b692-94bd591fb52f",
    x1: 12,
    y1: 160,
    x2: 12,
    y2: 117
  }), /*#__PURE__*/React.createElement("line", {
    className: "e9d71768-2015-48a9-b692-94bd591fb52f",
    x1: 35,
    y1: 160,
    x2: 35,
    y2: 117
  }), /*#__PURE__*/React.createElement("path", {
    className: "e9d71768-2015-48a9-b692-94bd591fb52f",
    d: "M12,117.17a11.5,11.5,0,0,1,23,0",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 176.5,
    r: 10.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "a79b4e26-55a2-4988-acd9-503bccd785e8",
    x1: 35.42,
    y1: 127.46,
    x2: 30.54,
    y2: 127.46
  }), /*#__PURE__*/React.createElement("line", {
    className: "a79b4e26-55a2-4988-acd9-503bccd785e8",
    x1: 35.5,
    y1: 133.5,
    x2: 30.5,
    y2: 133.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "a79b4e26-55a2-4988-acd9-503bccd785e8",
    x1: 35.5,
    y1: 139.5,
    x2: 30.5,
    y2: 139.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "e7113f9c-c57a-403e-b49e-d80a38b185d8",
    x1: 24,
    y1: 175,
    x2: 24,
    y2: 131
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "af15dc28-791c-486f-abb2-decb269b5ed8",
    "data-name": "fereastra copy"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "eae3bf02-3ca4-473c-a53a-952a2d6e8ddd",
    points: "24 104.49 24 5 195 5 195 176 44.87 176"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "eae3bf02-3ca4-473c-a53a-952a2d6e8ddd",
    x: 49.52,
    y: 27.69,
    width: 119.96,
    height: 125.62
  }))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "ea472750-dd51-4dbe-9fe2-e042b1899a49",
    x1: 137,
    y1: 41,
    x2: 158.5,
    y2: 62.5
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "ea472750-dd51-4dbe-9fe2-e042b1899a49",
    x1: 111,
    y1: 42,
    x2: 157.5,
    y2: 88.5
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoefTempFereastra);
export default __webpack_public_path__ + "static/media/coef_temp_fereastra.499b76f4f8e4098da25abe6482c2f603.svg";
export { ForwardRef as ReactComponent };